import Home from './pages/Home';
import Footer from './pages/Footer'
function App() {
  return (
    <>
      <h1 className='text-light mt-5 ' style={{ fontWeight: 'bold', fontSize: '3.5rem' }}><span style={{
        textShadow: '2px 1px white', color: '#f7c634'
      }}>Counter</span>  <span style={{
        color: "white",
        textShadow: '2px -2px #f7c634'
      }}> App</span></h1>
      <Home />
      <Footer />
    </>
  );
}

export default App;
